import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { concat, merge, of, from, Subscription, Subject } from 'rxjs';
import { map, switchMap, concatMap, debounceTime, finalize, distinctUntilChanged } from 'rxjs/operators';

import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { round1, round2 } from 'src/app/shared/round';

import { Product, ProductListFetchParams } from 'src/app/shared/product'
import { ProductGroup } from 'src/app/shared/product-group'

import { SecurityGroups } from 'src/app/shared/securitygroups';
import { CliListEntry } from 'src/app/shared/cli-list-entry';
import { Person } from 'src/app/shared/person';
import { Client } from 'src/app/shared/client';
import { DocListEntry, DocTypes } from 'src/app/shared/doc-list-entry';
import { Document, DocItems, DocInheritanceRule } from 'src/app/shared/document';
import { ProductInfo } from 'src/app/shared/product'
import { Currency } from 'src/app/shared/currency';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocumentStackService } from 'src/app/services/document-stack.service'

import { ProductApiService } from 'src/app/services/product-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';
import { RestApiService } from '../../services/rest-api.service';

@Component({
  selector: 'app-new-document-dlg-process-receipt',
  templateUrl: './new-document-dlg-process-receipt.component.html',
  styleUrls: ['./new-document-dlg-process-receipt.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessReceiptComponent implements OnInit, OnChanges, OnDestroy {

  private globalSettinsData: GlobalSettingsData;
  private _productInfoQuery: Subscription;

  /*
   * Consider that parentDocument may have or may NOT have items property filled with [actual] docItems
   */
  @Input() parentDocument: Document;

  /*
   * Therefore, to keep source object untouched (immutable ????)
   * we will expect alone/independent copy of DocItems as Input parameter
   * 
   */

  @Input() docItems: DocItems[];

  @Input() newDocument: Document;

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  parentDocumentId: number;

  count: number = -1;

  sourceDocItems: DocItems[];

  @Input() countEmptyDocItems: boolean = false;

  @Output() blocking: EventEmitter<boolean> = new EventEmitter();

  actions =
    [
      { name: 'На основе валютной цены', value: 1, disabled: false },
      { name: 'Удалить существующие позиции', value: 3, disabled: false },
      { name: 'Учитывать пустые строки', value: 10, disabled: false },
    ];

  selectedActions: any = [3];

  private listOptions$ = new Subject<number>();
  private currencyQuery: Subscription;

  constructor(
    private restApi: RestApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private prodApi: ProductApiService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgProcessReceiptComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'newDocument':
          if (this.newDocument) {
            this.processDocItems();
          }
          break;

        case 'docItems':
          if (this.docItems) {
            this.sourceDocItems = [... this.docItems];
            this.count = this.sourceDocItems.length;
            this.processDocItems();
          }
          break;

        case 'parentDocument':
          if (this.parentDocument) {

            if (this.parentDocument.items) {
              this.processDocItems();
            }
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgProcessReceiptComponent in ngOnDestroy')

    if (this.currencyQuery) { this.currencyQuery.unsubscribe(); }

    if (this._productInfoQuery) { this._productInfoQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgProcessReceiptComponent in ngOnInit');

    /*
     * TODO: Make subscription to newDocument currency rate, because it is quite complex task to wait the set the rate in the main thread
     * Potentially problematic due to different sources ??????
     */

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    /*
   * Get Actual currency rate for newDocument
   * Those one in newDocument.DOCRATEVAL from createNewDocument Dialog would arrive later
   * 
   */
    let rowSortIndex: number = 0;

    this.currencyQuery =
      this.listOptions$.pipe(
        debounceTime(50),
        switchMap(currid => this.restApi.getCurrencyInfoByID(currid).pipe(

          concatMap(rate => {
            console.log('*** NewDocumentDlgProcessReceiptComponent in Subscription: data=(' + JSON.stringify(rate) + ')');

            this.blocking.emit(true);

            this.newDocument.DOCRATEVAL = rate[0].CURRATE;
            this.newDocument.items = [];

            rowSortIndex = 10;

            return from(this.sourceDocItems).pipe(

              concatMap(di => {

                let ndi: DocItems = {
                  ...di,
                  ... {
                    DOCITEMID: -2,
                    cloneIndex: 0,
                    U4ETKA: null,
                    DOCITEMCURRID: this.newDocument.DOCCURRID,
                    DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                    PAYITEMCLIID: rowSortIndex,
                    PRODVAT: di.PRODVAT ?? this.globalSettinsData.vatValue,
                    DOCITEMTEXT1: '',
                    DOCITEMTEXT2: '',
                  }
                };

                let kVat = ((100.0 + ndi.PRODVAT) / 100.0); // <= 1,2 when VAT is 20%

                rowSortIndex += 10;

                ndi.DOCITEMPRICEWOVAT = round1((di.DOCITEMVPRICE * this.newDocument.DOCRATEVAL) / kVat);

                ndi.DOCITEMPRICE = round2(ndi.DOCITEMPRICEWOVAT * kVat);

                ndi.DOCITEMVPRICE = di.DOCITEMPRICE / this.newDocument.DOCRATEVAL;

                if (this.selectedActions.includes(1)) {
                  //console.log('*** NewDocumentDlgProcessReceiptComponent doCurrencyBased document ');

                  ndi.DOCITEMVPRICE = di.DOCITEMVPRICE;

                  ndi.DOCITEMPRICEWOVAT = round1((ndi.DOCITEMVPRICE * this.newDocument.DOCRATEVAL) / kVat);
                  ndi.DOCITEMPRICE = round2(ndi.DOCITEMPRICEWOVAT * kVat);
                }

                ndi.DOCITEMSUM = ndi.DOCITEMPRICE * ndi.DOCITEMQTY;

                //environment.production || console.table(ndi);

                return this.prodApi.getProdInfoById(
                  ndi.PRODID,
                  this.newDocument.DOCMANCLIID,
                  this.newDocument.DOCCURRID,
                  //
                  // It depends on document type ????
                  //
                  this.globalSettinsData.mainStockId,
                  this.globalSettinsData.impCountFlag ? this.globalSettinsData.impStockId : 0,
                  this.globalSettinsData.auxCountFlag ? this.globalSettinsData.auxStockId : 0,
                  //
                  // Is it on actual date or document date
                  // Could depends on....
                  //
                  new Date()
                ).pipe( map(data => this.newDocument.items.push({ ...ndi, ...{ prodInfo: data[0] } })));
              }),

              finalize(() => {
                //environment.production || console.table(this.newDocument.items);
                this.blocking.emit(false);
              })
            );
          }),
        )),
      )
      .subscribe();
    this.listOptions$.next(this.newDocument.DOCCURRID);
}

  processDocItems() {
    console.log('*** NewDocumentDlgProcessReceiptComponent in processDocItems');
    this.listOptions$.next(this.newDocument.DOCCURRID);
  }

  onDocTypeChanges(event) {
    console.log('*** NewDocumentDlgProcessReceiptComponent onDocTypeChanges ' + JSON.stringify(event));

    if (event.value.includes(1)) {
      console.log('*** NewDocumentDlgProcessReceiptComponent doCurrencyBased document ' + JSON.stringify(event.value));
      /*
       * TODO: Check whether currency of newDocument equal to those in parentDocument
       *       May be we need more sofisticated parameters checking
       */
    }
    if (event.value.includes(2)) {
      console.log('*** NewDocumentDlgProcessReceiptComponent copy U4etka info' + JSON.stringify(event.value));
    }
    this.processDocItems();
  }

  onClearRows(event) {
    console.log('*** NewDocumentDlgProcessReceiptComponent onClearRows ' + JSON.stringify(event));

    this.newDocument.items = [];
  }

  onRefreshRows(event) {
    console.log('*** NewDocumentDlgProcessReceiptComponent onRefreshRows ' + JSON.stringify(event));

    this.processDocItems();
  }

}
